<button type="button" class="micro-checkbox" mat-raised-button [ngClass]="{'primary': checked}" (click)="change(!checked)">
  <div class="hbox-nowrap">
    <mat-icon *ngIf="checked" class="pulsate-bck">{{radio ? 'radio_button_checked' : positiveIcon}}</mat-icon>
    <mat-icon *ngIf="!checked">{{radio ? 'radio_button_unchecked' : negativeIcon}}</mat-icon>
    <div *ngIf="checked && positive || !checked && negative" style="margin: auto;">{{checked ? positive : negative}}</div>
  </div>
</button>
